export const myAccountDataLocator = {
    choose_account_cta: 'delinquent_modal_choose_account_cta',
    close_delinquent_modal_cta: 'close_delinquent_modal_cta'
};